import { ArrowUpRight, Mail, Phone, MapPin, User } from "lucide-react";
import { useLang } from "@/lib/lang";
import { CONTACT, bookingHref } from "@/content";
import { Reveal } from "./Reveal";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;
  const items = [
    { Icon: Mail, label: c.email, value: CONTACT.email, href: `mailto:${CONTACT.email}`, id: "email" },
    { Icon: Phone, label: c.phone, value: CONTACT.phone, href: CONTACT.phoneHref, id: "phone" },
    { Icon: MapPin, label: c.address, value: CONTACT.address, id: "address" },
    { Icon: User, label: c.founder, value: CONTACT.founder, id: "founder" },
  ];
  return (
    <section id="contact" className="section relative overflow-hidden" data-testid="contact-section">
      <div className="contact-glow pointer-events-none absolute inset-0" />
      <div className="container-x relative">
        <Reveal><h2 className="max-w-5xl font-display text-4xl font-semibold leading-[1.02] tracking-[-0.035em] text-ink sm:text-6xl lg:text-7xl" data-testid="contact-title">{c.title}</h2></Reveal>
        <Reveal delay={0.1}><p className="mt-8 max-w-xl text-lg text-zinc-300">{c.body}</p></Reveal>
        <Reveal delay={0.15}>
          <a href={bookingHref()} target="_blank" rel="noopener noreferrer" className="btn-gold mt-10 px-8 py-4 text-base" data-testid="contact-book-btn">{t.cta} <ArrowUpRight size={20} /></a>
        </Reveal>
        <div className="mt-20 grid gap-px overflow-hidden rounded-[24px] border border-line bg-line sm:grid-cols-2 lg:grid-cols-4">
          {items.map(({ Icon, label, value, href, id }) => {
            const Tag = href ? "a" : "div";
            return (
              <Tag key={id} href={href} className="group bg-bg p-7 transition-colors duration-300 hover:bg-surface" data-testid={`contact-${id}`}>
                <Icon size={18} className="text-gold" />
                <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{label}</p>
                <p className="mt-2 text-ink">{value}</p>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
};
